import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '@services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { catchError, of, switchMap, tap, timer } from 'rxjs';

@Component({
  selector: 'ew-deactivate-user',
  templateUrl: './deactivate-user.component.html',
  styleUrl: './deactivate-user.component.scss',
})
export class DeactivateUserComponent implements OnInit {
  loading = false;
  userEmail: string = '';
  userId: string = '';

  constructor(
    public dialogRef: MatDialogRef<DeactivateUserComponent>,
    private API: ApiService,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: { userId: string; email: string },
  ) {}

  ngOnInit(): void {
    this.userEmail = this.data.email;
    this.userId = this.data.userId;
  }

  deactivateUser(): void {
    this.loading = true;

    this.API.post(`v1/users/${this.userId}/deactivate`, {})
      .pipe(
        tap((value) => {
          console.log(value);
          this.API.alertService.success(
            this.translate.instant('alert:deactivateUserSuccess'),
          );
        }),
        switchMap(() =>
          timer(2500).pipe(tap(() => this.dialogRef.close(true))),
        ),
        catchError(({ error: error }) => {
          this.API.alertService.error(
            this.translate.instant(error.message),
            error,
          );
          this.loading = false;
          return of(null);
        }),
      )
      .subscribe();
  }
}
